module.exports = __webpack_public_path__ + "assets/img/TGFyazIwMjAwMzAzLTE0Mzc0NDE1ODMyMTc0ODYyNzQ.2e04dff2.png";